 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import {PALETTE} from '../styles/paletteV3'
import {Threshold} from '../types/constEnums'
import relativeDate from '../utils/date/relativeDate'


const WarningMsg = styled('div')({
  background: PALETTE.GOLD_100,
  padding: '16px',
  fontSize: 16,
  borderRadius: 2,
  lineHeight: '26px',
  fontWeight: 500
})

const BoldText = styled('span')({
  fontWeight: 600
})

const OverLimitBlock = styled('div')({
  backgroundColor: PALETTE.GOLD_100,
  borderRadius: 2,
  color: PALETTE.SLATE_900,
  fontSize: 16,
  lineHeight: '24px',
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap'
})






const LimitExceededWarning = (props) => {
  const {organizationRef, domainId} = props
  const organization = useFragment(
    graphql`
      fragment LimitExceededWarning_organization on Organization {
        name
        scheduledLockAt
      }
    `,
    organizationRef
  )
  const {scheduledLockAt, name: orgName} = organization
  const isLocked = scheduledLockAt
    ? new Date(scheduledLockAt).getTime() <= new Date().getTime()
    : false

  return (
    React.createElement(OverLimitBlock, null
      , React.createElement(WarningMsg, null
        , React.createElement(BoldText, null, _nullishCoalesce(domainId, () => ( orgName)))
        , ` is over the limit of `
        , React.createElement(BoldText, null, `${Threshold.MAX_STARTER_TIER_TEAMS} free teams`)
        , scheduledLockAt && !isLocked && (
          React.createElement(React.Fragment, null
            , `. Your free access will end in `
            , React.createElement(BoldText, null, `${relativeDate(scheduledLockAt)}.`)
          )
        )
        , isLocked && `. Please upgrade to continue using Parabol.`
      )
    )
  )
}

export default LimitExceededWarning
